import { defaultCustomField } from "./state"

/**
 * Mutación para restablecer los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetCustomField(state) {
    state.customField = defaultCustomField()
}

/**
 * Mutación manipular/alterar la información del campo actual.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setCustomField(state, nextState) {
    state.customField = nextState
}

/**
 * Mutación manipular/alterar el listado de campos.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setCustomFields(state, nextState) {
    state.customFields = nextState
}

/**
 * Mutación manipular/alterar el estado de la acción que se esta realizando.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setAction(state, nextState) {
    state.action = nextState
}
